"use client";
import Image from "next/image";

import { WithMobile } from "@/lib/isMobile";

interface Props {
  deviceType?: {
    isMobile: boolean;
    isPad: boolean;
  };
  coreadvList: {
    title: string;
    img: string;
  }[];
}
function CoreadvEle({ deviceType, coreadvList }: Props) {
  return (
    <>
      <div className="text-[#333333] container relative pt-6 md:pt-8 pb-6 md:pb-44">
        <h3 className="text-xl md:text-3xl text-center">核心优势</h3>
        <div
          className="flex w-full flex-row flex-nowrap justify-between
              mt-6 md:mt-0
              md:absolute  md:bottom-0 md:translate-y-[40%]
              "
        >
          {coreadvList.map((item, idx) => (
            <div
              className="flex-center flex-col space-y-4 w-[374px]
                  md:border border-[#F2F2F2] bg-white
                  md:shadow-[0_4px_10px_0_rgba(0,0,0,0.1)]
                  md:py-8 md:rounded-lg
                  "
              key={idx}
            >
              <Image
                src={item.img}
                className="w-[55px] h-[55px] sm:w-[70px] sm:h-[70px] md:w-[110px] md:h-[110px]"
                alt={item.title}
                width="160"
                height="160"
                quality={100}
              />
              {/*  {deviceType!.isMobile ? (
                <Image
                  src={`/mobile/solution/coreadv${idx + 1}.png`}
                  className="w-[55px] h-[55px] sm:w-[70px] sm:h-[70px]"
                  alt="coreadv"
                  width="160"
                  height="160"
                  quality={100}
                />
              ) : (
                <Image
                  src={`/solution/coreadv${idx + 1}.png`}
                  className="w-[110px] h-[110px]"
                  alt="coreadv"
                  width="160"
                  height="160"
                  quality={100}
                />
              )} */}
              <p className="font-bold text-xs sm:text-sm md:text-lg">
                {item.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default WithMobile(CoreadvEle);
